"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ASPECT_RATIO = void 0;
var ASPECT_RATIO = {
  INSTA: 'INSTA',
  SQUARE: 'SQUARE',
  STANDARD: 'STANDARD',
  WIDE: 'WIDE'
};
exports.ASPECT_RATIO = ASPECT_RATIO;